import api from "./api";
import auth from "./auth";

export default {
    getWhitelist(page = 1) {
        return new Promise((resolve, reject) => {
            api.get("customer-service/cms/customer/whitelist/" + page, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },

    getWhitelistType() {
        return new Promise((resolve, reject) => {
            api.get("merchant-service/cms/settings/topups", auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                })
        });
    },

    importWhitelist(fields) {
        return new Promise((resolve, reject) => {
            api.post("customer-service/cms/customer/import-whitelist",
                fields,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    deleteWhitelist(uuid) {
        return new Promise((resolve, reject) => {
            api.delete("customer-service/cms/customer/whitelist/delete/" + uuid, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                })
        });
    }
}